module.exports = __webpack_public_path__ + "fonts/lato-v17-latin-regular.b4d2c4c3.woff2";